import { axiosInterceptor } from "../AxiosInterceptor";

export default class ExamFiledStudentsRepository {
  static async studentsList(queryString = "") {
    let result = {
      status: false,
      data: null,
    };
    try {
      const response = await axiosInterceptor.get(
        "/reports/exam-failed-students/?" + queryString
      );
      if (response.status === 200) {
        result = { ...result, status: true, data: response.data.data };
      }
    } catch (e) {
      result = { ...result, nonFieldErrors: "Ma'lumot olib bo'lmadi" };
    }
    return result;
  }
}
